import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export function StarIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" fill="currentColor" boxSize="16px" {...props}>
      <path d="M10 0L12.5 7.5L20 7.5L14 12.5L16.5 20L10 15L3.5 20L6 12.5L0 7.5L7.5 7.5L10 0Z" />
    </Icon>
  );
}
